import React, { useState, useEffect, useRef } from 'react'
import Image from 'next/image'
import styles from './FilterModal.module.scss'
import FilterTypes from '../FilterTypes'

export default function FilterModal({
  toggleVisibility,
  visible,
  features,
  actives,
  types,
  callback,
  orderBy,
  count,
  isLoading,
  largeButtonText,
  typeCallback,
  activeIndex,
  setCurrentPage,
}) {
  if (actives === null || !visible) return null

  const clearTypesRef = useRef(false)

  const { types: activeTypes, features: activeFeatures } = actives

  const [featuresToSend, setFeaturesToSend] = useState(activeFeatures)
  const [activeOrderBy, setOrderBy] = useState(orderBy)
  const [isManuallyOperated, setIsManuallyOperated] = useState(false)
  const [taxonomy, setTaxonomy] = useState([])
  const [orderToClear, setOrderToClear] = useState(false)

  const updateQuery = () => {
    const newQuery = []

    /**
     * Only reset pagination if user is the one making selections
     * Same action may be triggered by initial load of filters from store.
     *
     */
    const resetPagination = isManuallyOperated

    if (activeTypes.length > 0 && !clearTypesRef.current) {
      newQuery.push({
        filter: 'event_type',
        values: activeTypes,
      })
    }

    if (featuresToSend.length > 0) {
      newQuery.push({
        filter: 'event_feature',
        values: featuresToSend,
      })
    }

    callback(newQuery, resetPagination, activeOrderBy)
    if (activeIndex !== undefined && activeIndex !== null) {
      typeCallback(
        newQuery,
        types[activeIndex].name,
        orderToClear ? null : activeIndex,
      )
    }
    clearTypesRef.current = false
  }

  const formTaxonomy = (inputFeatures, highLevelCategory) => {
    if (!inputFeatures || !highLevelCategory) return []

    const orderList = [
      'Suosituimmat',
      'Tilatyyppi',
      'Tyyppi',
      'Ominaisuudet',
      'Hintatasot',
      'Tekniikka ja varustus',
      'Genre',
      'Lisäpalvelut',
    ]

    const featuresInThisCategory = inputFeatures.filter((f) =>
      f.feature_category
        .toLowerCase()
        .startsWith(highLevelCategory.toLowerCase()),
    )

    let headings = featuresInThisCategory.map(
      (f) => f.feature_category.split('->')[1],
    )

    headings = [...new Set(headings)] // Remove duplicates

    // Set headings in the order defined in orderList
    headings.sort((a, b) => {
      return orderList.indexOf(a) - orderList.indexOf(b)
    })

    return headings.map((heading) => {
      return {
        masterType: heading,
        subTypes: featuresInThisCategory.filter(
          (f) => f.feature_category.split('->')[1] === heading,
        ),
      }
    })
  }

  useEffect(() => {
    setTaxonomy(formTaxonomy(features, largeButtonText))
  }, [largeButtonText])

  const getButtonClassName = (slug) => {
    if (activeFeatures.includes(slug)) {
      return 'btn btn--secondary btn--small btn--active-pink'
    }

    return 'btn btn--secondary btn--small'
  }

  const toggleActiveFeature = (slug) => {
    setIsManuallyOperated(true)
    if (activeFeatures.includes(slug)) {
      const newActives = activeFeatures.filter((active) => active !== slug)
      setFeaturesToSend(newActives)
    } else {
      const newActives = [...activeFeatures, slug]
      setFeaturesToSend(newActives)
    }
  }

  const clearAll = () => {
    setFeaturesToSend([])
    clearTypesRef.current = true
    // eslint-disable-next-line no-use-before-define
    handleSort('rand')
    setOrderToClear(true)
  }

  const handleBackdropClick = () => {
    toggleVisibility()
  }

  const handleSort = (name) => {
    setOrderBy(name)
  }

  useEffect(() => {
    updateQuery()
  }, [featuresToSend])

  return (
    <div className={styles.element}>
      <div className={styles.backdrop} onClick={handleBackdropClick}></div>
      <div className={styles.modalWrapper}>
        <div className={styles.modal}>
          <div className={styles.modalHeader}>
            <h3 className={styles.heading}>Tarkenna hakua</h3>
            <div className={styles.close} onClick={toggleVisibility}>
              <Image
                src="/img/x-lg.svg"
                width="24"
                height="24"
                objectFit="fill"
              />
            </div>
          </div>
          <div className={styles.modalContent}>
            <FilterTypes
              actives={actives}
              types={types}
              callback={typeCallback}
              activeIndex={activeIndex}
              setCurrentPage={setCurrentPage}
              ordering="grid"
            />
            {largeButtonText &&
              taxonomy.map((item, itemKey) => {
                return (
                  <div key={itemKey} className={styles.section}>
                    <h4 className={styles.sectionHeading}>{item.masterType}</h4>
                    <div className={styles.subFilters}>
                      {item.subTypes.map((filter, filterKey) => {
                        return (
                          <div key={filterKey} className={styles.buttonWrapper}>
                            <button
                              className={getButtonClassName(filter.slug)}
                              onClick={() => toggleActiveFeature(filter.slug)}
                            >
                              {filter.name}
                            </button>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
          </div>
          <div className={styles.modalFooter}>
            <p className={styles.link} role="button" onClick={clearAll}>
              Tyhjennä kaikki
            </p>
            {isLoading ? (
              <button className="btn btn--primary" onClick={toggleVisibility}>
                Etsitään...
              </button>
            ) : (
              <button className="btn btn--primary" onClick={toggleVisibility}>
                Hae {count} kohdetta
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
